import type { IAntdConfig } from '@/Core/Contracts/Configs'
import uk from 'antd/locale/uk_UA'

import { BrandConfig } from '@/Ship/Configs/BrandConfig'

/**
 * Конфігурація Antd
 */
export const AntdConfig: IAntdConfig = {
    /** Розмір компонентів */
    componentSize: 'large',
    /** Конфігурація теми */
    theme: {
        /** Токени теми */
        token: {
            colorPrimary: BrandConfig.color,
            colorInfo: BrandConfig.color,
            colorLink: BrandConfig.color,
            borderRadius: 8,
            fontFamily: 'Montserrat',
            borderRadiusLG: 8,
            borderRadiusSM: 4,
        },
        /*
         * Алгоритму (світла/темна) і кольорів, що від нього залежать, тут
         * свідомо немає — їх задає `Ship/Components/Theme/ThemeProvider` над
         * ядровим `Layout`. Ядро читає цей конфіг один раз, а вкладений
         * провайдер antd бере в батька лише те, чого не задає сам: стояв би тут
         * `algorithm` чи світла рамка — перемикач теми їх би не перебив.
         */
        /**
         * Використання CSS змінних.
         *
         * У цій версії antd `cssVar` — це об'єкт налаштувань, а не прапорець:
         * порожній вмикає режим зі значеннями за замовчуванням. Раніше тут
         * стояло `true`, і тип не сходився.
         */
        cssVar: {},
    },
    /** Базова локаль за замовчуванням */
    locale: uk,
}
